import React from 'react'
import { Tr, Td, useDisclosure, Collapse, Box, Text, Flex, IconButton, Badge, Button, Link, Tooltip } from '@chakra-ui/react'
import { FiChevronDown, FiChevronUp, FiExternalLink } from 'react-icons/fi'

const formatarData = (dataString) => {
  if (!dataString) return ''

  try {
    const data = new Date(dataString)
    return data.toLocaleDateString('pt-BR')
  } catch (e) {
    return dataString
  }
}

const LinhaTrocaComponent = ({ troca }) => {
  const { isOpen, onToggle } = useDisclosure()

  const handleToggle = () => {
    onToggle()
  }

  return (
    <>
      <Tr>
        <Td p={2} borderRight="1px" borderColor="gray.100" borderBottom="none">
          <IconButton
            aria-label={isOpen ? 'Fechar detalhes' : 'Ver detalhes'}
            icon={isOpen ? <FiChevronUp /> : <FiChevronDown />}
            size="sm"
            onClick={handleToggle}
            variant="ghost"
          />
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {formatarData(troca.data_solicitacao)}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none" maxWidth="70px">
          <Tooltip label={troca.nome_fornecedor} placement="top">
            <Text isTruncated>{troca.nome_fornecedor}</Text>
          </Tooltip>
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {troca.link_nota ? (
            <Link href={troca.link_nota} isExternal color="blue.500" textDecoration="underline" display="inline-flex" alignItems="center">
              {troca.nota_fiscal}
              <FiExternalLink style={{ marginLeft: '4px' }} />
            </Link>
          ) : (
            troca.nota_fiscal
          )}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none" maxWidth="150px">
          <Tooltip label={troca.descricao_produto} placement="top">
            <Text isTruncated>{troca.descricao_produto}</Text>
          </Tooltip>
        </Td>
        <Td isNumeric borderRight="1px" borderColor="gray.100" borderBottom="none">
          {troca.qtd_produto}
        </Td>
        <Td isNumeric borderRight="1px" borderColor="gray.100" borderBottom="none">
          {troca.qtd_troca}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          <Badge colorScheme="blue" fontSize="0.9em" px={2} py={1}>
            {troca.numero_pedido}
          </Badge>
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {troca.pedido_spot ? (
            <Badge colorScheme="purple" fontSize="0.9em" px={2} py={1}>
              {troca.pedido_spot}
            </Badge>
          ) : (
            <Text fontSize="sm" color="gray.500">
              -
            </Text>
          )}
        </Td>
      </Tr>
      <Tr>
        <Td colSpan={9} p={0} borderTop="none">
          <Collapse in={isOpen} animateOpacity>
            <Box p={4} bg="white" borderTop="1px" borderColor="gray.100">
              <Flex direction="column" gap={2}>
                <Text fontWeight="bold">Detalhes da Troca:</Text>

                <Flex justify="space-between">
                  <Text fontWeight="medium">Código do Produto:</Text>
                  <Text>{troca.codigo_produto || 'Não informado'}</Text>
                </Flex>

                <Flex justify="space-between" align="center">
                  <Text fontWeight="medium">Nota Fiscal:</Text>
                  <Flex align="center" gap={2}>
                    <Text>{troca.nota_fiscal}</Text>
                    {troca.link_nota && (
                      <Button as="a" href={troca.link_nota} target="_blank" size="xs" colorScheme="blue" leftIcon={<FiExternalLink />}>
                        Visualizar
                      </Button>
                    )}
                  </Flex>
                </Flex>

                <Flex justify="space-between">
                  <Text fontWeight="medium">Data da Solicitação:</Text>
                  <Text>{formatarData(troca.data_solicitacao)}</Text>
                </Flex>

                {troca.pedido_spot && (
                  <Flex justify="space-between">
                    <Text fontWeight="medium">Número do Pedido SPOT:</Text>
                    <Text>{troca.pedido_spot}</Text>
                  </Flex>
                )}
              </Flex>
            </Box>
          </Collapse>
        </Td>
      </Tr>
    </>
  )
}

export const LinhaTroca = React.memo(LinhaTrocaComponent)
